import Home from "./components/Home.vue";
import Message from "./pages/messagedashboard.vue";
import Support from "./components/Support.vue";
import Careers from "./pages/careers";
import CareersList from "./pages/careerslist";
import CareersDetails from "./pages/careersdetail";
import Privacy from "./pages/privacy";
import AboutGunspring from "./pages/aboutgunspring";
import TermsOfService from "./pages/termsofservice";
import Register from "./pages/register";
import Recover from "./pages/recover";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Merchant from "./pages/merchantapp";
import apps from "./pages/userapps";
import echeck from "./pages/e-checkapps";
import Confirm from "./pages/emailconfirm";
import ResetPassword from "./pages/resetpassword";
import Crypto from "./pages/cryptoapp";
import Chargeback from "./pages/chargebackshieldapp";
import ErrorPage from "./pages/error_page/appsorry";
import Admin from "./pages/admin";
import AdminDetail from "./pages/adminDetail";
import AdminEdit from "./pages/adminEdit";
import JobsCreate from "./pages/jobscreate";

const routes = [
  { path: "/", name: "home", component: Home },
  { path: "/message", name: "Message", component: Message },
  { path: "/message/:channel", name: "message-admin", component: Message },
  { path: "/support", name: "support", component: Support },
  { path: "/careers", name: "careers", component: Careers },
  { path: "/careers/all", name: "careerslist", component: CareersList },
  { path: "/careers/detail/:job_id", name: "careersdetails", component: CareersDetails },
  { path: "/privacy-policy", name: "privacy", component: Privacy },
  { path: "/about-gunspring", name: "about-gunspring", component: AboutGunspring },
  { path: "/terms-of-service", name: "terms-of-service", component: TermsOfService },
  { path: "/register", name: "register", component: Register },
  { path: "/recover", name: "recover", component: Recover },
  { path: "/logout", name: "logout", component: Logout },
  {
    path: "/account/email-verify/:key",
    name: "confirm",
    component: Confirm,
    meta: {
      emailconfirm: true
    }
  },
  { path: "/account/reset/:key", name: "reset", component: ResetPassword },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      requiresLogged: true,
    },
  },
  {
    path: "/apps/merchantapps",
    name: "merchant",
    component: Merchant,
    meta: {
      requiresApp: true,
    },
  },
  {
    path: "/apps/echeckapps",
    name: "echeck",
    component: echeck,
    meta: {
      requiresApp: true,
    },
  },
  {
    path: "/apps/cryptoapp",
    name: "crypto",
    component: Crypto,
    meta: {
      requiresApp: true,
    },
  },
  {
    path: "/apps/chargebackshieldapp",
    name: "chargeback",
    component: Chargeback,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/apps",
    name: "userapps",
    component: apps,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/apps/error",
    name: "sorry",
    component: ErrorPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/apps/:key/detail/:app",
    name: "admin-apss-detail",
    component: AdminDetail,
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/apps/:key/edit/:app",
    name: "admin-apss-edit",
    component: AdminEdit,
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/jobs/create",
    name: "jobdashboardcreate",
    component: JobsCreate,
    meta: {
      requiresAdmin: true,
    },
  },

];

export default routes;
